module.exports.config = {
  "declarative": true,
  "render-module": {
    "name": "PieceMaxiLogoRenderModule",
    "path": "front/piece-maxi-logo-render.module"
  },
  "definition": {
    "type": "pieceMaxiLogo",
    "name": "PieceMaxiLogoDefinition",
    "group": "Media",
    "availablePlatforms": ["web", "apps"],
    "description": "MaxiLogo",
    "isNew": true,
    "fields": [
      {
        "name": "Image",
        "type": "linkedImages",
        "mandatory": true
      },
      {
        "name": "preloadImage",
        "label": "Precargar imagen en SSR",
        "type": "boolean",
        "defaultValue": false,
        "isExcluded": true
      },
      {
        "name": "enableFadeEffect",
        "label": "Activar efecto desvanecimiento",
        "type": "boolean",
        "defaultValue": false
      },
      {
        "name": "isInsideSliceSlider",
        "label": "¿Está dentro de un slice-slider?",
        "type": "boolean",
        "defaultValue": false
      },
      {
        "name": "objectPosition",
        "label": "Posición de la imagen",
        "type": "optionsSelect",
        "section": "styles",
        "defaultValue": "center-center",
        "values": [
          { "value": "top-left", "label": "Arriba a la izquierda" },
          { "value": "top-center", "label": "Arriba al centro" },
          { "value": "top-right", "label": "Arriba a la derecha" },
          { "value": "center-left", "label": "Centrado a la izquierda" },
          { "value": "center-center", "label": "Centrado al centro" },
          { "value": "center-right", "label": "Centrado a la derecha" },
          { "value": "bottom-left", "label": "Abajo a la izquierda" },
          { "value": "bottom-center", "label": "Abajo al centro" },
          { "value": "bottom-right", "label": "Abajo a la derecha" },
        ]
      },
      {
        "name": "objectFit",
        "label": "Proporción de la imagen",
        "type": "options",
        "section": "styles",
        "defaultValue": "cover",
        "values": [
          { "value": "contain", "label": "Contain" },
          { "value": "cover", "label": "Cover" }
        ]
      },
      {
        "name": "zIndex",
        "label": "Z-Index",
        "type": "plainText",
        "defaultValue": "1",
        "mandatory": false,
        "validators": ["positiveInteger"]
      }
    ]
  }
};
